import { Component, ElementRef, ViewChild, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { MatSnackBar } from '@angular/material';
import { DataSource } from '@angular/cdk/collections';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/observable/fromEvent';

import { md5 } from './../Global/md5';

import { ServiciosGenerales } from '../Servicios/ServiciosGenerales.service';
import { CrearUsuarioModel } from './CrearUsuario.model';
import { ParamEstadosUsuario } from './CrearUsuario.model';
import { ParamRoles } from './CrearUsuario.model';
import { MchUsuariosId } from './CrearUsuario.model';
import { ParamRolesId } from './CrearUsuario.model';


import { OpcionModel } from '../Global/Opcion.model';

declare function validateisEmail(email: string): boolean;


@Component({
	selector: 'notas',
	templateUrl: './CrearUsuario.component.html',
	styleUrls: ['../../../../styles.css']
})


export class CrearUsuarioComponent {

	// ~~~~~ Variables para el manejo de permisos ~~~~~ //
	public btnAgregar: boolean;
	public btnEditar: boolean;
	public btnEliminar: boolean;
	// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ //

	filteredOptions: Observable<OpcionModel[]>;
	myControl = new FormControl();

	public form: FormGroup;
	public formErrors: any;

	public usuario: CrearUsuarioModel;
	public roles: Array<OpcionModel> = new Array();

	public nidrol: number;


	private editar: boolean = false;
	public activarUsuario: boolean = true;
	public cantidadContratos: number = 0;
	public agregarUsuarios: boolean = false;
	public cargando: boolean = false;

	public mensaje: string = "";
	public ocultar: boolean = false;

	public bloquear : boolean = true;

	constructor(private formBuilder: FormBuilder, private _serviciosGenerales: ServiciosGenerales, public snackBar: MatSnackBar,
		private _route: ActivatedRoute, private _router: Router, public dialog: MatDialog) {



		// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
		this.btnAgregar = _serviciosGenerales.seguridad.isAgregar();
		this.btnEditar = _serviciosGenerales.seguridad.isEditar();
		this.btnEliminar = _serviciosGenerales.seguridad.isEliminar();
		// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

		this.snackBar.dismiss();

		this.usuario = new CrearUsuarioModel(new MchUsuariosId("", 0, 0), "", "", "", "", "", "", new ParamEstadosUsuario(1), 0, "*",1);

		this.formErrors = {

			cusuario: {},
			cnumid: {},
			vnombre: {},
			vapellido: {},
			cmail: {},
			nidrol: {},
			cip: {}
		};



	}


	ngOnInit() {

		console.log("#####", JSON.parse(this._serviciosGenerales.seguridad.getInfoToken().ntipoempresa));

		this.inicializarForm("", false, "", false, "*");
		this.form.valueChanges.subscribe(() => {
			this.onFormValuesChanged();
		});


		this._serviciosGenerales.get('consultarRoles', { ntipoempresa: -1 }).subscribe(result => {
			for (let x in result)
				this.roles.push(new OpcionModel(result[x].nidrol, result[x].cdescriprol));

			this._route.params.subscribe(params => {

				if (!!params['cusuario'] && !!params['cnumid']) {
					this.agregarUsuarios = true;
					this._serviciosGenerales.get('informacionUsuario', { cnumid: params['cnumid'], cusuario: params['cusuario'] }).subscribe(result => {
						let x = result[0];
						this.usuario = new CrearUsuarioModel(new MchUsuariosId(params['cusuario'], x.nidrol, x.ntipoempresa), x.dfecultcambio, params['cnumid'], x.vnombre, x.vapellido, x.cmail, x.cvlave, new ParamEstadosUsuario(x.nestado), x.bloquear, x.cip.replace('*', '* '),1);
						if (this.usuario.bloquear == 1)
							this.activarUsuario = false;


						this.inicializarForm(params['cusuario'], true, params['cnumid'], true, x.cip);
						this.editar = true;
						this.cantidadContratos = x.cantidadContratos;

					}, error => {
						console.log(error, '');
						this.openSnackBarEspecial("Ocurrió un error al momento de consultar la información del usuario", "X");
					})
				}
			})

		}, error => {
			console.log(error, '');
			this.openSnackBarEspecial("Ocurrió un error mientras se cargan los perfiles disponibles", "X");
		})

	}


	validarDatos() {

		this._serviciosGenerales.get('validarDatosUsuario', { cnumid: this.usuario.cnumid.toUpperCase().trim(), cmail: this.usuario.cmail.toUpperCase().trim(), cusuario: this.usuario.id.cusuario.toUpperCase().trim() }).subscribe(result => {

			if (result[0].usuario > 0) {
				this.openSnackBarEspecial("El nombre de usuario: " + this.usuario.id.cusuario + " ya está registrado en el sistema", "X");
			} 
			/*else if (result[0].cedula > 0) {
				this.openSnackBar("La cédula: " + this.usuario.cnumid + " ya está registrada en el sistema", "X");
			} else if (result[0].email > 0) {
				this.openSnackBar("El Email: " + this.usuario.cmail + " ya está registrado en el sistema", "X");
			}*/
		}, error => {
			console.log(error, '');
			this.openSnackBarEspecial("Ocurrió un error al momento de validar los datos del usuario", "X");
		})
	}


	guardar() {

		if (this.form.valid == false) {
			this.openSnackBarEspecial("Hay campos requeridos sin llenar", "X");
			return;
		}

		if (validateisEmail(this.usuario.cmail) == false ) {
			this.openSnackBarEspecial('Correo no valido, ingrese un correo una dirección de correo valida','X');
			return;
		}

		if (this.editar == true) {
			this.guardarEditar();
			return;
		}

		this._serviciosGenerales.get('validarDatosUsuario', { cnumid: this.usuario.cnumid.toUpperCase().trim(), cmail: this.usuario.cmail.toUpperCase().trim(), cusuario: this.usuario.id.cusuario.toUpperCase().trim() }).subscribe(result => {

			if (result[0].usuario > 0) {
				this.openSnackBarEspecial("El nombre de usuario: " + this.usuario.id.cusuario + " ya está registrado en el sistema", "X");
			} 
			/*else if (result[0].cedula > 0) {
				this.openSnackBar("La cédula: " + this.usuario.cnumid + " ya está registrada en el sistema", "X");
			} else if (result[0].email > 0) {
				this.openSnackBar("El Email: " + this.usuario.cmail + " ya está registrado en el sistema", "X");
			} */
			else {
				this.guardarEditar();
			}
		}, error => {
			console.log(error, '');
			this.openSnackBarEspecial("Ocurrió un error al momento de validar los datos del usuario", "X");
		})

		console.log(this.usuario);

	}


	private guardarEditar() {

		this.usuario.cnumid = this.usuario.cnumid.trim();
		//this.usuario.cvlave ="";
		this.usuario.bloquear = (this.activarUsuario == false ? 1 : 0);
		this.usuario.paramEstadosUsuario.nestado = (this.activarUsuario == true ? 1 : 2);
		this.usuario.cip = this.usuario.cip.replace(" ", "");
		this.usuario.id.ntipoempresa = JSON.parse(this._serviciosGenerales.seguridad.getInfoToken().ntipoempresa).ntipoempresa;
		this.usuario.id.ntipoempresa = JSON.parse(this._serviciosGenerales.seguridad.getInfoToken().ntipoempresa).ntipoempresa;

		this._serviciosGenerales.post('guardar/usuarioSistema', this.usuario).subscribe(
			result => {
				if (result.error != undefined && result.error == true) {
					this.openSnackBarEspecial(result.mensaje, "X");
					return;
				}
				this.openSnackBar("Usuario Guardado Correctamente", "X");
				this.form.reset();
				this.form.clearValidators();
				this.usuario = new CrearUsuarioModel(new MchUsuariosId("", 0, 0), "", "", "", "", "", "", new ParamEstadosUsuario(1), 0, "*",1);
				this.nidrol = 0;
				this._router.navigate(['/UsuarioIndex']);

			}, error => {
				console.log(error, '');
				this.openSnackBarEspecial("Ocurrió un error al momento de guardar la información", "X");
			});
	}


	private inicializarForm(cusuarioValue, cusuarioDisabled, cnumidValue, cnumidDisabled, cip) {

		this.form = this.formBuilder.group({

			cusuario: [{
				value: cusuarioValue,
				disabled: cusuarioDisabled
			}, Validators.required],
			cnumid: [{
				value: cnumidValue,
				disabled: cnumidDisabled
			}, Validators.required],
			vnombre: ['', Validators.required],
			vapellido: ['', Validators.required],
			cmail: ['', Validators.required],
			nidrol: ['', Validators.required],
			cip: ['', Validators.required]

		});

	}

	onFormValuesChanged() {
		for (const field in this.formErrors) {
			if (!this.formErrors.hasOwnProperty(field)) {
				continue;
			}

			// Clear previous errors
			this.formErrors[field] = {};

			// Get the control
			const control = this.form.get(field);

			if (control && control.dirty && !control.valid) {
				this.formErrors[field] = control.errors;
			}
		}
	}


	navegar(){
		this.bloquear = true;
		this._router.navigate(['UsuarioIndex']);
	}

	openSnackBar(message: string, action: string) {
		this.snackBar.open(message, action, {
			duration: 20000
		});

	}

	openSnackBarEspecial(message: string, action: string) {
		let snackBarRef =  this.snackBar.open(message, action);

		snackBarRef.onAction().subscribe(() => {
		
			this.ocultar = false;
			this.mensaje = "";
		});
		
		let shand = document.getElementsByClassName('mat-snack-bar-container') as HTMLCollectionOf<HTMLElement>;		
		
		if (shand.length != 0) {
			    for (let i=0;i<shand.length;i++){
				shand[i].style.backgroundColor = "rgb(255 204 214)";
				}
			}
	}


}





// WEBPACK FOOTER //
// D:/REPO/FacturacionWeb/src/app/main/content/AdministracionUsuarios/CrearUsuario.component.ts